/*
* Copyright (C) Regione Lombardia
*/
export enum RuoloEnum {
    AMMINISTRATORE = 1,
    OPERATORE = 2,
    CONSULTATORE = 3,
    ALTRI_ATTORI = 4,
}
